import request from '@/utils/request'

let Proxy_consultationApi = {

  /*代理咨询列表*/
  list(data) {
    return request._post('/shop/plus.proxy_consultation.Index/index', data);
},
/*添加代理咨询*/
add(data) {
    return request._post('/shop/plus.proxy_consultation.Index/add', data);
},
/*修改代理咨询*/
edit(data) {
    return request._post('/shop/plus.proxy_consultation.Index/edit', data);
},
/*删除代理咨询*/
del(data) {
    return request._post('/shop/plus.proxy_consultation.Index/del', data);
},
/*代理咨询详情*/
detail(data) {
  return request._post('/shop/plus.proxy_consultation.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.proxy_consultation.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.proxy_consultation.Setting/getSetting', data, errorback);
    },
}
export default Proxy_consultationApi;



// WEBPACK FOOTER //
// ./src/api/proxy_consultation.js